import { TextField } from '@mui/material';
import styled from 'styled-components';

export const StyledTextField = styled(TextField)`
    & .MuiInput-root {
        font-size: 0.8rem;
        font-family: 'Noto Sans', sans-serif;
    }
`;
